import { createFileRoute, useNavigate, useRouteContext } from '@tanstack/react-router';
import { RecipeForm } from '@/features/recipes/RecipeForm';
import { useCreateRecipe } from '@/features/recipes/mutations';
import { defaultFormValues } from '@/features/recipes/formMapping';

export const Route = createFileRoute('/_authed/recipes/new')({
  component: NewRecipe,
});

function NewRecipe() {
  const navigate = useNavigate();
  const create = useCreateRecipe();
  const { me } = useRouteContext({ from: '/_authed' });
  return (
    <div>
      <header className="px-4 pt-4 sm:px-6 sm:pt-6 xl:px-8 xl:pt-8">
        <h1 className="font-serif text-3xl leading-tight">New recipe</h1>
      </header>
      <RecipeForm
        mode="create"
        me={me}
        initialValues={defaultFormValues()}
        onSave={async (values) => {
          await create.mutateAsync(values);
          await navigate({ to: '/recipes' });
        }}
        onCancel={async () => { await navigate({ to: '/recipes' }); }}
      />
    </div>
  );
}
